<template>
  <div
    :class="[$style.toast_cmp, $style.sso_toast_cmp]"
    class="gp_autotest_sso_toast"
  >
    <div
      :class="$style.message"
      v-html="locales('warning_team_only_sso')"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      locales: __,
    };
  },
};
</script>

<style module src="./toasts.less"></style>
